<template>
    <div class="py-2 container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="pb-0 card-header">
              <div class="d-lg-flex">
                <div>
                  <h5 class="mb-0">Informativos</h5>
                </div>
                <div class="my-auto mt-4 ms-auto mt-lg-0">
                  <div class="my-auto ms-auto">
                    <router-link :to="{ name: 'Informativo Login Hotel', params: { id: 'new' } }">
                      <button class="mt-1 mb-0 btn btn-outline-success btn-sm mt-sm-0" type="button" name="button">
                        +&nbsp; Novo Informativo
                      </button>
                    </router-link>
                  </div>
                </div>
              </div>
              <filtro-modulos :status="status" :set-status="onSetStatus" v-model="search" :placeholder="'Pesquisar informativo'"/>
            </div>
            <div class="px-4 py-2 mt-4">
              <div v-if="informativosFiltered.length > 0" class="row">
                <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" v-for="informativo in informativosFiltered" :key="informativo.id">
                  <card-informativos :informativo="informativo" />
                </div>
              </div>
              <div v-else class="text-center py-5">
                <i class="fas fa-search mb-3" style="font-size: 2rem; color: #6c757d;"></i>
                <h5 class="text-muted">Nenhum informativo encontrado</h5>
                <p class="text-muted mb-0" v-if="search || status !== 'T'">
                  Tente ajustar os filtros de busca
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import FiltroModulos from '../components/FiltroModulos.vue';
import cardInformativos from './components/cardInformativos.vue';
import api from '@/services/api';
import { errorToast } from '@/utils/alerts';

export default {
    name: "InformativosLogin",
    components: {
        FiltroModulos,
        cardInformativos
    },
    data() {
        return {
            informativos: [],
            informativosFiltered: [],
            status: 'T',
            search: ''
        }
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            api.get(`/informativos-login`).then(response => {
                const { data } = response;

                this.informativos = data;
                this.informativosFiltered = data;

            }).catch(() => errorToast('Erro ao carregar informativos'));
        },
        onSetStatus(status) {
            this.status = status;
            this.filterInformativos();
        },
        filterInformativos() {
            const { status, search } = this;
            const currentDate = new Date();

            let items = [
                ...this.informativos
            ];

            if (status !== 'T') {
                items = items.filter(item => {
                    const dataFinal = new Date(item.dataFinal);
                    const isAtivo = dataFinal > currentDate;
                    return status === 'A' ? isAtivo : !isAtivo;
                });
            }

            if (search) {
                const searchLower = search.toLowerCase();
                items = items.filter(item =>
                    item.descricao?.toLowerCase().includes(searchLower) ||
                    item.titulo?.toLowerCase().includes(searchLower)
                );
            }

            this.informativosFiltered = items;
        }
    },
    watch: {
        search: function () {
            this.filterInformativos();
        }
    }
}

</script>